<template>
</template>

<script>
import { mapState } from 'vuex';
import { ensureGtmLoaded, pushEcommerceEvent, readMap, writeMap, enrichItem } from 'assets/js/gtm';

export default {
    name: "PT507GTMRemoveFromCart",
    data() {
        return {
            eventSent: false,
        };
    },
    computed: {
        ...mapState('pt180', ['pt180Init']),
        cartItems() {
            return this.pt180Init && Array.isArray(this.pt180Init.searchList) ? this.pt180Init.searchList : [];
        },
        gtmContainerId() {
            return this.pt180Init && this.pt180Init.gtmcontainerId ? this.pt180Init.gtmcontainerId : '';
        },
        eventPayloadReady() {
            return !!this.gtmContainerId;
        }
    },
    watch: {
        eventPayloadReady: {
            handler(ready) {
                if (ready) {
                    this.$nextTick(() => {
                        this.cartItems.length && this.init();
                    });
                }
            },
            immediate: true,
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.cartItems.length && this.init();
            $(document).on('click', '.cartDeleteLink', this.delCartHandler);
            $(document).on('click', '#cart-nav-list input[name="delete_all"]:eq(0)', this.delAllCartHandler);
        });
    },
    destroyed() {
        $(document).off('click', '.cartDeleteLink', this.delCartHandler);
        $(document).off('click', '#cart-nav-list input[name="delete_all"]:eq(0)', this.delAllCartHandler);
    },
    methods: {
        hasCartRoot() {
            return !!document.querySelector('.cartDeleteLink');
        },
        canRunInContext() {
            return this.hasCartRoot();
        },
        init() {
            if (!this.eventPayloadReady || !this.canRunInContext()) {
                return;
            }
            this.$store.commit('setGtmId', this.gtmContainerId);
            ensureGtmLoaded();
        },
        toNumber(value, fallback = 0) {
            const numeric = Number(value);
            return Number.isNaN(numeric) ? fallback : numeric;
        },
        buildCartItem(item = {}) {
            const quantity = this.toNumber(item.QTY, 1);
            return {
                item_id: item.M_ITEM_CD,
                item_name: item.WEB_ITEM_NM,
                quantity: quantity > 0 ? quantity : 1,
                price: item.SALE_TNK,
                ...(enrichItem(item.M_ITEM_CD) ? enrichItem(item.M_ITEM_CD) : {})
            };
        },
        delCartHandler(e) {
            if (!this.canRunInContext()) {
                return;
            }
            const $btn = $(e.currentTarget)
            const index = $btn.parents('.itemList').find('.divNo').text() || 1
            this.pushRemoveCart(Number(index) - 1);
        },
        delAllCartHandler() {
            // console.log("🚀 ~ methods.delAllCartHandler:")
            if (!this.canRunInContext()) {
                return;
            }
            this.pushRemoveCart('all');
        },
        pushRemoveCart(index) {
            if (this.eventSent || !this.eventPayloadReady || !this.canRunInContext()) {
                return;
            }
            if (index === 'all') {
                const items = this.cartItems.map(item => this.buildCartItem(item));
                const value = items.reduce((total, item) => {
                return total + (this.toNumber(item.price, 0) * this.toNumber(item.quantity, 1));
            }, 0);

                pushEcommerceEvent('remove_from_cart', {
                    currency: 'JPY',
                    value,
                    items
                });
                return
            }
            const items = this.cartItems.map(item => this.buildCartItem(item));
            const value = [items[index]].reduce((total, item) => {
                return total + (this.toNumber(item.price, 0) * this.toNumber(item.quantity, 1));
            }, 0);

            pushEcommerceEvent('remove_from_cart', {
                currency: 'JPY',
                value,
                items: [items[index]],
            });
            // ショッピングカートから商品を削除した後、ローカルから元のレコードを削除する
            const map = readMap()
            delete map[items[index].item_id]
            writeMap(map)

            this.eventSent = true;
        }
    }
}
</script>
